'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var queryString = require('query-string');

var axios = _interopDefault(require('axios'));

var Url = require('url');

var lodash = require('lodash');
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

/* global Reflect, Promise */


var _extendStatics = function extendStatics(d, b) {
  _extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return _extendStatics(d, b);
};

function __extends(d, b) {
  _extendStatics(d, b);

  function __() {
    this.constructor = d;
  }

  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return _assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function __generator(thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
}

function __values(o) {
  var m = typeof Symbol === "function" && o[Symbol.iterator],
      i = 0;
  if (m) return m.call(o);
  return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
}

function __read(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
}

function __spread() {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read(arguments[i]));
  }

  return ar;
}

var version = "2.1.0"; // Copyright 2019 Cognite AS

var CogniteError =
/** @class */
function (_super) {
  __extends(CogniteError, _super);
  /** @hidden */


  function CogniteError(errorMessage, status, requestId, extra) {
    if (extra === void 0) {
      extra = {};
    }

    var _this = this;

    var message = errorMessage + " | code: " + status;

    if (requestId) {
      message += " | X-Request-ID: " + requestId;
    }

    var missing = extra.missing,
        duplicated = extra.duplicated;

    if (missing || duplicated) {
      message += "\n" + JSON.stringify(extra, null, 2);
    }

    _this = _super.call(this, message) || this;
    Object.setPrototypeOf(_this, CogniteError.prototype); // https://stackoverflow.com/questions/51229574/why-instanceof-returns-false-for-a-child-object-in-javascript

    _this.errorMessage = errorMessage;
    _this.status = status;
    _this.requestId = requestId;
    _this.missing = missing;
    _this.duplicated = duplicated;

    if (Error.captureStackTrace) {
      Error.captureStackTrace(_this, _this.constructor);
    } else {
      _this.stack = new Error(message).stack;
    }

    return _this;
  }

  CogniteError.prototype.toJSON = function () {
    var jsonObject = {
      status: this.status,
      message: this.errorMessage
    };

    if (this.requestId) {
      jsonObject.requestId = this.requestId;
    }

    if (this.missing) {
      jsonObject.missing = this.missing;
    }

    if (this.duplicated) {
      jsonObject.duplicated = this.duplicated;
    }

    return jsonObject;
  };

  return CogniteError;
}(Error);
/** @hidden */


function handleErrorResponse(err) {
  var code;
  var message;
  var requestId;
  var missing;
  var duplicated;

  try {
    code = err.response.status;
    message = err.response.data.error.message;
    missing = err.response.data.error.missing;
    duplicated = err.response.data.error.duplicated;
    requestId = (err.response.headers || {})['X-Request-Id'];
  } catch (_) {
    throw err;
  }

  throw new CogniteError(message, code, requestId, {
    missing: missing,
    duplicated: duplicated
  });
} // Copyright 2019 Cognite AS

/** @hidden */


var API_VERSION = 'v1';
/** @hidden */

var BASE_URL = 'https://api.cognitedata.com'; // Copyright 2019 Cognite AS

/** @hidden */

function getBaseUrl(baseUrl) {
  return baseUrl || BASE_URL;
}
/** @hidden */


var apiUrl = function apiUrl() {
  return "/api/" + API_VERSION;
};
/** @hidden */


function projectUrl(project) {
  return apiUrl() + "/projects/" + encodeURIComponent(project);
}
/** @hidden */


function removeParameterFromUrl(url, parameter) {
  return url.replace(new RegExp('[?&]' + parameter + '=[^&#]*(#.*)?$'), '$1').replace(new RegExp('([?&])' + parameter + '=[^&]*&'), '$1');
}
/** @hidden */


function sleepPromise(durationInMs) {
  return new Promise(function (resolve) {
    setTimeout(resolve, durationInMs);
  });
}
/** @hidden */


function promiseCache(promiseFn) {
  var unresolvedPromise = null;
  return function () {
    if (unresolvedPromise) {
      return unresolvedPromise;
    }

    return unresolvedPromise = promiseFn().then(function (res) {
      unresolvedPromise = null;
      return res;
    });
  };
}
/** @hidden */


function isSameProject(project1, project2) {
  return project1.toLowerCase() === project2.toLowerCase();
}
/** @hidden */


function transformDateInRequest(data) {
  return lodash.cloneDeepWith(data, function (value) {
    if (value instanceof Date) {
      return value.getTime();
    }
  });
}
/** @hidden */


function transformDateInResponse(data) {
  var dateKeys = ['createdTime', 'lastUpdatedTime', 'uploadedTime', 'deletedTime', 'timestamp'];
  return lodash.cloneDeepWith(data, function (value, key) {
    if (dateKeys.indexOf('' + key) !== -1) {
      return new Date(value);
    }
  });
} // Copyright 2019 Cognite AS


function attach(instance) {
  var _this = this;

  var onFulfilled = function onFulfilled(res) {
    return res;
  };

  var onError = function onError(err) {
    return __awaiter(_this, void 0, void 0, function () {
      var config, delay;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            config = err.config.raxConfig || {};
            config.currentRetryAttempt = config.currentRetryAttempt || 0;
            err.config.raxConfig = config;

            if (!config.shouldRetry(err)) {
              return [2
              /*return*/
              , Promise.reject(err)];
            }

            delay = (Math.pow(2, config.currentRetryAttempt) - 1) / 2 * 1000;
            err.config.raxConfig.currentRetryAttempt += 1;
            return [4
            /*yield*/
            , sleepPromise(delay)];

          case 1:
            _a.sent();

            return [2
            /*return*/
            , config.instance.request(err.config)];
        }
      });
    });
  };

  return instance.interceptors.response.use(onFulfilled, onError);
}

var httpMethodsToRetry = ['GET', 'HEAD', 'OPTIONS', 'DELETE', 'PUT'];
var statusCodesToRetry = [[100, 199], [429, 429], [500, 599]];
/** @hidden */

function addRetryToAxiosInstance(instance) {
  // config for retry-axios package
  instance.defaults.raxConfig = {
    instance: instance,
    retryDelay: 250,
    numRetries: 5,
    shouldRetry: function shouldRetry(err) {
      var config = err.config;
      var _a = config.raxConfig,
          currentRetryAttempt = _a.currentRetryAttempt,
          numRetries = _a.numRetries,
          isSafeToRetry = _a.isSafeToRetry;

      if (currentRetryAttempt >= numRetries) {
        return false;
      }

      if (!config.method) {
        return true;
      }

      var httpMethod = config.method.toUpperCase();

      if (!isSafeToRetry && httpMethodsToRetry.indexOf(httpMethod) === -1) {
        return false;
      }

      if (!err.response) {
        return false;
      }

      var responseStatusCode = err.response.status;
      var isCodeInValidRange = false;
      statusCodesToRetry.forEach(function (_a) {
        var _b = __read(_a, 2),
            start = _b[0],
            end = _b[1];

        if (responseStatusCode >= start && responseStatusCode <= end) {
          isCodeInValidRange = true;
        }
      });
      return isCodeInValidRange;
    }
  };
  attach(instance);
}
/** @hidden */


function makeRequestSafeToRetry(config) {
  var raxConfig = config.raxConfig || {};
  raxConfig.isSafeToRetry = true;
  config.raxConfig = raxConfig;
} // Copyright 2019 Cognite AS

/** @hidden */


function generateAxiosInstance(baseUrl, appId) {
  var headers = {
    'x-cdp-sdk': "CogniteJavaScriptSDK:" + version
  };

  if (appId) {
    headers['x-cdp-app'] = appId;
  }

  return addArraySerializer(addTokenLeakageProtection(axios.create({
    baseURL: baseUrl,
    headers: headers
  })));
}
/** @hidden */


function setBearerToken(axiosInstance, token) {
  axiosInstance.defaults.headers.Authorization = "Bearer " + token;
}
/** @hidden */


function listenForNonSuccessStatusCode(axiosInstance, status, handler) {
  axiosInstance.interceptors.response.use(function (response) {
    return response;
  }, function (error) {
    var response = error.response || {};

    if (response.status === status) {
      var retry = function retry() {
        return rawRequest(axiosInstance, error.config);
      };

      return handler(error, retry);
    }

    return Promise.reject(error);
  });
}
/** @hidden */


function rawRequest(axiosInstance, requestConfig, isSafeToRetry) {
  if (isSafeToRetry === void 0) {
    isSafeToRetry = false;
  }

  return __awaiter(this, void 0, void 0, function () {
    var response, e_1;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (isSafeToRetry) {
            makeRequestSafeToRetry(requestConfig);
          }

          requestConfig.data = transformDateInRequest(requestConfig.data);
          requestConfig.params = transformDateInRequest(requestConfig.params || {});
          _a.label = 1;

        case 1:
          _a.trys.push([1, 3,, 4]);

          return [4
          /*yield*/
          , axiosInstance(requestConfig)];

        case 2:
          response = _a.sent();
          response.data = transformDateInResponse(response.data);
          return [2
          /*return*/
          , response];

        case 3:
          e_1 = _a.sent();
          throw handleErrorResponse(e_1);

        case 4:
          return [2
          /*return*/
          ];
      }
    });
  });
}

function isSameOrigin(baseUrl, newUrl) {
  var baseUrlParsed = Url.parse(baseUrl);
  var newUrlParsed = Url.parse(Url.resolve(baseUrl, newUrl)); // check that protocol and hostname are the same

  return baseUrlParsed.protocol === newUrlParsed.protocol && baseUrlParsed.host === newUrlParsed.host;
}

function addTokenLeakageProtection(axiosInstance) {
  axiosInstance.interceptors.request.use(function (config) {
    var isUnknownDomain = !isSameOrigin(config.baseURL || '', config.url || '');

    if (isUnknownDomain) {
      var newHeaders = _assign({}, config.headers);

      delete newHeaders.Authorization;
      config.headers = newHeaders;
    }

    return config;
  });
  return axiosInstance;
}

function addArraySerializer(axiosInstance) {
  axiosInstance.interceptors.request.use(function (config) {
    // loop through params
    Object.keys(config.params || {}).forEach(function (key) {
      var param = config.params[key];

      if (Array.isArray(param)) {
        config.params[key] = JSON.stringify(param);
      }
    });
    return config;
  });
  return axiosInstance;
} // Copyright 2019 Cognite AS


var CogniteLoginError =
/** @class */
function (_super) {
  __extends(CogniteLoginError, _super);

  function CogniteLoginError(message) {
    var _this = _super.call(this, message || 'Not able to login') || this;

    if (Error.captureStackTrace) {
      Error.captureStackTrace(_this, _this.constructor);
    } else {
      _this.stack = new Error(_this.message).stack;
    }

    return _this;
  }

  return CogniteLoginError;
}(Error); // Copyright 2019 Cognite AS


var ACCESS_TOKEN_PARAM = 'access_token';
var ID_TOKEN_PARAM = 'id_token';
var ERROR_PARAM = 'error';
var ERROR_DESCRIPTION_PARAM = 'error_description';
var LOGIN_IFRAME_NAME = 'cognite-js-sdk-auth-iframe';
var LOGIN_POPUP_NAME = 'cognite-js-sdk-auth-popup';
/** @hidden */

function getIdInfoFromAccessToken$$1(axiosInstance, accessToken) {
  return getIdInfo$$1(axiosInstance, {
    Authorization: "Bearer " + accessToken
  });
}
/** @hidden */


function loginSilently$$1(axiosInstance, params) {
  return __awaiter(this, void 0, void 0, function () {
    var project, tokens, _a, baseUrl, href, tokens, _1;

    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          if (isAuthIFrame()) {
            // don't resolve when inside iframe (we don't want to do any logic)
            return [2
            /*return*/
            , new Promise(function () {})];
          }

          project = params.project;
          tokens = extractTokensFromUrl();
          _a = tokens !== null;
          if (!_a) return [3
          /*break*/
          , 2];
          return [4
          /*yield*/
          , isTokensValid$$1(axiosInstance, project, tokens)];

        case 1:
          _a = _b.sent();
          _b.label = 2;

        case 2:
          if (_a) {
            clearParametersFromUrl(ACCESS_TOKEN_PARAM, ID_TOKEN_PARAM);
            return [2
            /*return*/
            , tokens];
          }

          baseUrl = params.baseUrl;
          _b.label = 3;

        case 3:
          _b.trys.push([3, 5,, 6]);

          href = window.location.href;
          return [4
          /*yield*/
          , silentLogin({
            baseUrl: baseUrl,
            project: project,
            redirectUrl: href,
            errorRedirectUrl: href
          })];

        case 4:
          tokens = _b.sent();

          if (tokens !== null) {
            return [2
            /*return*/
            , tokens];
          }

          return [3
          /*break*/
          , 6];

        case 5:
          _1 = _b.sent();
          return [3
          /*break*/
          , 6];

        case 6:
          return [2
          /*return*/
          , null];
      }
    });
  });
}
/** @hidden */


function getIdInfo$$1(axiosInstance, headers) {
  return __awaiter(this, void 0, void 0, function () {
    var response, _a, loggedIn, user, project, err_1;

    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          _b.trys.push([0, 2,, 3]);

          return [4
          /*yield*/
          , rawRequest(axiosInstance, {
            method: 'get',
            url: '/login/status',
            headers: headers
          })];

        case 1:
          response = _b.sent();
          _a = response.data.data, loggedIn = _a.loggedIn, user = _a.user, project = _a.project;

          if (!loggedIn) {
            return [2
            /*return*/
            , null];
          }

          return [2
          /*return*/
          , {
            user: user,
            project: project
          }];

        case 2:
          err_1 = _b.sent();

          if (err_1.status === 401) {
            return [2
            /*return*/
            , null];
          }

          throw err_1;

        case 3:
          return [2
          /*return*/
          ];
      }
    });
  });
}

function clearParametersFromUrl() {
  var params = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    params[_i] = arguments[_i];
  }

  var url = window.location.href;
  params.forEach(function (param) {
    url = removeParameterFromUrl(url, param);
  });
  window.history.replaceState(null, '', url);
}

function generateLoginUrl(params) {
  var project = params.project,
      baseUrl = params.baseUrl,
      redirectUrl = params.redirectUrl,
      errorRedirectUrl = params.errorRedirectUrl;
  var queryParams = {
    project: project,
    redirectUrl: redirectUrl,
    errorRedirectUrl: errorRedirectUrl || redirectUrl
  };
  return baseUrl + "/login/redirect?" + queryString.stringify(queryParams);
}
/** @hidden */


function loginWithRedirect$$1(params) {
  return new Promise(function () {
    var url = generateLoginUrl(params);
    window.location.assign(url); // don't resolve promise since we do redirect
  });
}
/** @hidden */


function loginWithPopup$$1(params) {
  return new Promise(function (resolve, reject) {
    var url = generateLoginUrl(params);
    var loginPopup = window.open(url, LOGIN_POPUP_NAME, // https://www.quackit.com/javascript/popup_windows.cfm
    'height=500,width=400,left=100,top=100,resizable=yes,scrollbars=yes,toolbar=yes,menubar=no,location=no,directories=no, status=yes');

    if (loginPopup === null) {
      reject(new CogniteLoginError('Failed to create login popup window'));
      return;
    }

    var tokenListener = function tokenListener(message) {
      if (message.source !== loginPopup) {
        return;
      }

      if (!message.data || message.data.error) {
        reject(new CogniteLoginError());
        return;
      }

      window.removeEventListener('message', tokenListener);
      resolve(message.data);
    };

    window.addEventListener('message', tokenListener, false);
  });
}

function isLoginPopupWindow$$1() {
  return window.name === LOGIN_POPUP_NAME;
}

function loginPopupHandler$$1() {
  if (!isLoginPopupWindow$$1()) {
    return;
  }

  try {
    var tokens = parseTokenQueryParameters(window.location.search);
    window.opener.postMessage(tokens);
  } catch (err) {
    window.opener.postMessage({
      error: err.message
    });
  } finally {
    window.close();
  }
}

function isAuthIFrame() {
  return window.name === LOGIN_IFRAME_NAME;
}

function parseTokenQueryParameters(query) {
  var _a = queryString.parse(query),
      _b = ACCESS_TOKEN_PARAM,
      accessToken = _a[_b],
      _c = ID_TOKEN_PARAM,
      idToken = _a[_c],
      _d = ERROR_PARAM,
      error = _a[_d],
      _e = ERROR_DESCRIPTION_PARAM,
      errorDescription = _a[_e];

  if (error !== undefined) {
    throw Error(error + ": " + errorDescription);
  }

  if (lodash.isString(accessToken) && lodash.isString(idToken)) {
    return {
      accessToken: accessToken,
      idToken: idToken
    };
  }

  return null;
}

function extractTokensFromUrl() {
  var tokens;

  try {
    tokens = parseTokenQueryParameters(window.location.search);
    clearParametersFromUrl(ACCESS_TOKEN_PARAM, ID_TOKEN_PARAM);
    return tokens;
  } catch (err) {
    clearParametersFromUrl(ERROR_PARAM, ERROR_DESCRIPTION_PARAM);
    throw err;
  }
}

function silentLogin(params) {
  return __awaiter(this, void 0, void 0, function () {
    return __generator(this, function (_a) {
      return [2
      /*return*/
      , new Promise(function (resolve, reject) {
        var iframe = document.createElement('iframe');
        iframe.name = LOGIN_IFRAME_NAME;
        iframe.style.width = '0';
        iframe.style.height = '0';
        iframe.style.border = '0';
        iframe.style.border = 'none';

        iframe.onload = function () {
          try {
            var authTokens = parseTokenQueryParameters(iframe.contentWindow.location.search);

            if (authTokens === null) {
              throw Error('Failed to login');
            }

            resolve(authTokens);
          } catch (e) {
            reject(e);
          } finally {
            document.body.removeChild(iframe);
          }
        };

        iframe.src = generateLoginUrl(params) + "&prompt=none";
        document.body.appendChild(iframe);
      })];
    });
  });
}
/** @hidden */


function isTokensValid$$1(axiosInstance, project, tokens) {
  return __awaiter(this, void 0, void 0, function () {
    var idInfo;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4
          /*yield*/
          , getIdInfoFromAccessToken$$1(axiosInstance, tokens.accessToken)];

        case 1:
          idInfo = _a.sent();
          return [2
          /*return*/
          , idInfo !== null && isSameProject(idInfo.project, project)];
      }
    });
  });
}
/** @hidden */


function createAuthenticateFunction$$1(options) {
  var _this = this;

  var project = options.project,
      axiosInstance = options.axiosInstance,
      onTokens = options.onTokens,
      onAuthenticate = options.onAuthenticate;
  var baseUrl = getBaseUrl(axiosInstance.defaults.baseURL);
  return promiseCache(function () {
    return __awaiter(_this, void 0, void 0, function () {
      var handleTokens, tokens;

      var _this = this;

      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            handleTokens = function handleTokens(tokens) {
              setBearerToken(axiosInstance, tokens.accessToken);

              if (onTokens) {
                onTokens(tokens);
              }
            };

            return [4
            /*yield*/
            , loginSilently$$1(axiosInstance, {
              baseUrl: baseUrl,
              project: project
            })];

          case 1:
            tokens = _a.sent();

            if (tokens) {
              handleTokens(tokens);
              return [2
              /*return*/
              , true];
            }

            return [2
            /*return*/
            , new Promise(function (resolve, reject) {
              var login = {
                skip: function skip() {
                  resolve(false);
                },
                redirect: function redirect(params) {
                  var authorizeParams = _assign({
                    baseUrl: baseUrl,
                    project: project
                  }, params);

                  loginWithRedirect$$1(authorizeParams).catch(reject);
                },
                popup: function popup(params) {
                  return __awaiter(_this, void 0, void 0, function () {
                    var authorizeParams;
                    return __generator(this, function (_a) {
                      authorizeParams = _assign({
                        baseUrl: baseUrl,
                        project: project
                      }, params);
                      loginWithPopup$$1(authorizeParams).then(function (tokens) {
                        if (tokens) {
                          handleTokens(tokens);
                          resolve(true);
                        }

                        throw new CogniteLoginError();
                      }).catch(reject);
                      return [2
                      /*return*/
                      ];
                    });
                  });
                }
              };
              onAuthenticate(login);
            })];
        }
      });
    });
  });
} // Copyright 2019 Cognite AS

/** @hidden */


var MetadataMap =
/** @class */
function () {
  function MetadataMap() {
    this.map = new WeakMap();
  }

  MetadataMap.prototype.addAndReturn = function (value, metadata) {
    this.map.set(value, {
      // we extract out only what is necessary
      status: metadata.status,
      headers: metadata.headers
    });
    return value;
  };

  MetadataMap.prototype.get = function (value) {
    return this.map.get(value);
  };

  return MetadataMap;
}(); // Copyright 2019 Cognite AS
// polyfill


if (Symbol.asyncIterator === undefined) {
  Symbol.asyncIterator = Symbol.for('asyncIterator');
}
/** @hidden */


function makeAutoPaginationMethods(firstPagePromise) {
  var _a;

  var listPromise = firstPagePromise;
  var i = 0;

  function iterate(listResult) {
    if (i < listResult.items.length) {
      return {
        value: listResult.items[i++],
        done: false
      };
    } else if (listResult.next) {
      // reset counter, request next page, and recurse.
      i = 0;
      listPromise = listResult.next();
      return listPromise.then(iterate);
    }

    return {
      value: undefined,
      done: true
    }; // https://github.com/Microsoft/TypeScript/issues/11375#issuecomment-413037242
  }

  function asyncIteratorNext() {
    return __awaiter(this, void 0, void 0, function () {
      var listResult;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , listPromise];

          case 1:
            listResult = _a.sent();
            return [2
            /*return*/
            , iterate(listResult)];
        }
      });
    });
  }

  var autoPagingEach = makeAutoPagingEach(asyncIteratorNext);
  var autoPagingToArray = makeAutoPagingToArray(autoPagingEach);
  var autoPaginationMethods = (_a = {
    autoPagingEach: autoPagingEach,
    autoPagingToArray: autoPagingToArray,
    // Async iterator functions:
    next: asyncIteratorNext,
    return: function _return() {
      // This is required for `break`.
      return {};
    }
  }, _a[Symbol.asyncIterator] = function () {
    return autoPaginationMethods;
  }, _a);
  return autoPaginationMethods;
}

function makeAutoPagingEach(asyncIteratorNext) {
  return function autoPagingEach(handler) {
    return __awaiter(this, void 0, void 0, function () {
      function iterate() {
        return __awaiter(this, void 0, void 0, function () {
          var iterResult, item, shouldContinue;
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                return [4
                /*yield*/
                , asyncIteratorNext()];

              case 1:
                iterResult = _a.sent();

                if (iterResult.done) {
                  return [2
                  /*return*/
                  ];
                }

                item = iterResult.value;
                return [4
                /*yield*/
                , handler(item)];

              case 2:
                shouldContinue = _a.sent();

                if (shouldContinue === false) {
                  return [2
                  /*return*/
                  ];
                }

                return [4
                /*yield*/
                , iterate()];

              case 3:
                _a.sent();

                return [2
                /*return*/
                ];
            }
          });
        });
      }

      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , iterate()];

          case 1:
            _a.sent();

            return [2
            /*return*/
            ];
        }
      });
    });
  };
}

function makeAutoPagingToArray(autoPagingEach) {
  return function autoPagingToArray(options) {
    return __awaiter(this, void 0, void 0, function () {
      var limit, items;

      var _this = this;

      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            limit = options && options.limit || 25;

            if (limit === -1) {
              limit = Infinity;
            }

            items = [];
            return [4
            /*yield*/
            , autoPagingEach(function (item) {
              return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  items.push(item);

                  if (items.length >= limit) {
                    return [2
                    /*return*/
                    , false];
                  }

                  return [2
                  /*return*/
                  ];
                });
              });
            })];

          case 1:
            _a.sent();

            return [2
            /*return*/
            , items];
        }
      });
    });
  };
} // Copyright 2019 Cognite AS

/** @hidden */


var Queue =
/** @class */
function () {
  function Queue() {
    var _this = this;

    this.add = function (item) {
      _this.data.unshift(item);
    };

    this.remove = function () {
      _this.data.pop();
    };

    this.first = function () {
      return _this.data[0];
    };

    this.last = function () {
      return _this.data[_this.data.length - 1];
    };

    this.size = function () {
      return _this.data.length;
    };

    this.data = [];
  }

  return Queue;
}(); // Copyright 2019 Cognite AS

/** @hidden */


function topologicalSort(nodes) {
  var queue = new Queue();
  var sortedList = [];
  var childrenMap = getChildrenMap(nodes); // insert root nodes

  nodes.forEach(function (node) {
    if (!node.parentNode) {
      queue.add(node);
    }
  });

  while (queue.size() !== 0) {
    var node = queue.last();
    queue.remove();
    sortedList.push(node);
    var children = childrenMap.get(node);

    if (children) {
      children.forEach(queue.add);
    }
  }

  if (sortedList.length !== nodes.length) {
    throw Error('Impossible to topological sort nodes');
  }

  return sortedList;
}

function getChildrenMap(nodes) {
  var childrenMap = new Map();
  nodes.forEach(function (node) {
    childrenMap.set(node, []);
  });
  nodes.forEach(function (node) {
    var parentNode = node.parentNode;

    if (parentNode) {
      childrenMap.get(parentNode).push(node);
    }
  });
  return childrenMap;
} // Copyright 2019 Cognite AS


var CogniteMultiError =
/** @class */
function (_super) {
  __extends(CogniteMultiError, _super);

  function CogniteMultiError(_a) {
    var e_1, _b;

    var succeded = _a.succeded,
        responses = _a.responses,
        failed = _a.failed,
        errors = _a.errors;

    var _this = _super.call(this, "The API Failed to process some items\n" + JSON.stringify({
      succeded: succeded,
      responses: responses,
      failed: failed,
      errors: errors
    }, null, 2)) || this;

    _this.missing = [];
    _this.duplicated = [];
    _this.statuses = [];
    _this.requestIds = [];
    _this.responses = [];
    Object.setPrototypeOf(_this, CogniteMultiError.prototype); // https://stackoverflow.com/questions/51229574/why-instanceof-returns-false-for-a-child-object-in-javascript

    _this.responses = responses.map(function (response) {
      return response.data;
    });
    _this.errors = errors;
    _this.succeded = succeded.reduce(function (all, current) {
      return all.concat(current);
    }, []);
    _this.failed = failed.reduce(function (all, current) {
      return all.concat(current);
    }, []);
    _this.status = errors[0].status;
    _this.requestId = errors[0].requestId;

    try {
      for (var errors_1 = __values(errors), errors_1_1 = errors_1.next(); !errors_1_1.done; errors_1_1 = errors_1.next()) {
        var err = errors_1_1.value;

        if (err instanceof CogniteError) {
          if (err.missing) {
            _this.missing = _this.missing.concat(err.missing);
          }

          if (err.duplicated) {
            _this.duplicated = _this.duplicated.concat(err.duplicated);
          }

          if (err.requestId) {
            _this.requestIds.push(err.requestId);
          }

          _this.statuses.push(err.status);
        }
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (errors_1_1 && !errors_1_1.done && (_b = errors_1.return)) _b.call(errors_1);
      } finally {
        if (e_1) throw e_1.error;
      }
    }

    if (Error.captureStackTrace) {
      Error.captureStackTrace(_this, _this.constructor);
    } else {
      _this.stack = new Error(_this.message).stack;
    }

    return _this;
  }

  return CogniteMultiError;
}(Error); // Copyright 2019 Cognite AS

/** @hidden */


function assetChunker(assets, chunkSize) {
  if (chunkSize === void 0) {
    chunkSize = 1000;
  }

  var nodes = assets.map(function (asset) {
    return {
      data: asset
    };
  }); // find all new exteralIds and map the new externalId to the asset

  var externalIdMap = new Map();
  nodes.forEach(function (node) {
    var externalId = node.data.externalId;

    if (externalId) {
      externalIdMap.set(externalId, node);
    }
  }); // set correct Node.parentNode

  nodes.forEach(function (node) {
    var parentExternalId = node.data.parentExternalId; // has an internal parent

    if (parentExternalId && externalIdMap.has(parentExternalId)) {
      node.parentNode = externalIdMap.get(parentExternalId);
    }
  });
  var sortedNodes = topologicalSort(nodes);
  return lodash.chunk(sortedNodes.map(function (node) {
    return node.data;
  }), chunkSize);
}
/**
 * Resolves all Promises at once, even if some of them fail
 */

/** @hidden */


function promiseAllAtOnce(inputs, promiser) {
  return __awaiter(this, void 0, void 0, function () {
    var failed, succeded, responses, errors, promises, wrappedPromises;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          failed = [];
          succeded = [];
          responses = [];
          errors = [];
          promises = inputs.map(function (input) {
            return promiser(input);
          });
          wrappedPromises = promises.map(function (promise, index) {
            return promise.then(function (result) {
              succeded.push(inputs[index]);
              responses.push(result);
            }).catch(function (error) {
              failed.push(inputs[index]);
              errors.push(error);
            });
          });
          return [4
          /*yield*/
          , Promise.all(wrappedPromises)];

        case 1:
          _a.sent();

          if (failed.length) {
            throw {
              succeded: succeded,
              responses: responses,
              failed: failed,
              errors: errors
            };
          }

          return [2
          /*return*/
          , responses];
      }
    });
  });
}
/** @hidden */


function promiseAllWithData(inputs, promiser, runSequentially) {
  return __awaiter(this, void 0, void 0, function () {
    var err_1;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          _a.trys.push([0, 5,, 6]);

          if (!runSequentially) return [3
          /*break*/
          , 2];
          return [4
          /*yield*/
          , promiseEachInSequence(inputs, promiser)];

        case 1:
          return [2
          /*return*/
          , _a.sent()];

        case 2:
          return [4
          /*yield*/
          , promiseAllAtOnce(inputs, promiser)];

        case 3:
          return [2
          /*return*/
          , _a.sent()];

        case 4:
          return [3
          /*break*/
          , 6];

        case 5:
          err_1 = _a.sent();
          throw new CogniteMultiError(err_1);

        case 6:
          return [2
          /*return*/
          ];
      }
    });
  });
}
/**
 * Resolves Promises sequentially
 */

/** @hidden */


function promiseEachInSequence(inputs, promiser) {
  return __awaiter(this, void 0, void 0, function () {
    var _this = this;

    return __generator(this, function (_a) {
      return [2
      /*return*/
      , inputs.reduce(function (previousPromise, input, index) {
        return __awaiter(_this, void 0, void 0, function () {
          var prevResult, _a, _b, err_2;

          return __generator(this, function (_c) {
            switch (_c.label) {
              case 0:
                return [4
                /*yield*/
                , previousPromise];

              case 1:
                prevResult = _c.sent();
                _c.label = 2;

              case 2:
                _c.trys.push([2, 4,, 5]);

                _b = (_a = prevResult).concat;
                return [4
                /*yield*/
                , promiser(input)];

              case 3:
                return [2
                /*return*/
                , _b.apply(_a, [_c.sent()])];

              case 4:
                err_2 = _c.sent();
                throw {
                  errors: [err_2],
                  failed: inputs.slice(index),
                  succeded: inputs.slice(0, index),
                  responses: prevResult
                };

              case 5:
                return [2
                /*return*/
                ];
            }
          });
        });
      }, Promise.resolve(new Array()))];
    });
  });
} // Copyright 2019 Cognite AS


function noTransformFunction(items) {
  return items;
}
/** @hidden */


function generateCreateEndpoint(axiosInstance, resourcePath, metadataMap, transform, chunkFunction) {
  if (transform === void 0) {
    transform = noTransformFunction;
  }

  return function create(itemsArray) {
    return __awaiter(this, void 0, void 0, function () {
      var chunks, itemIndex, chunkIndexToItemsIndex, responses, mergedResponses, sortedResponse;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            chunks = doChunking(itemsArray, chunkFunction);
            itemIndex = new Map();
            itemsArray.forEach(function (item, index) {
              itemIndex.set(item, index);
            });
            chunkIndexToItemsIndex = new Map();
            lodash.concat.apply(void 0, __spread([[]], chunks)).forEach(function (item, index) {
              var originalIndex = itemIndex.get(item);
              chunkIndexToItemsIndex.set(index, originalIndex);
            });
            return [4
            /*yield*/
            , promiseAllWithData(chunks, function (input) {
              return rawRequest(axiosInstance, {
                method: 'post',
                url: resourcePath,
                data: {
                  items: input
                }
              });
            }, true)];

          case 1:
            responses = _a.sent();
            mergedResponses = lodash.concat.apply(void 0, __spread([[]], responses.map(function (response) {
              return response.data.items;
            })));
            sortedResponse = [];
            mergedResponses.forEach(function (item, index) {
              var originalIndex = chunkIndexToItemsIndex.get(index);
              sortedResponse[originalIndex] = item;
            });
            return [2
            /*return*/
            , metadataMap.addAndReturn(transform(sortedResponse), responses[0])];
        }
      });
    });
  };
}
/** @hidden */


function listByGet(axiosInstance, resourcePath, filter) {
  return rawRequest(axiosInstance, {
    method: 'get',
    url: resourcePath,
    params: filter
  }, true);
}
/** @hidden */


function listByPost(axiosInstance, resourcePath, filter) {
  return rawRequest(axiosInstance, {
    method: 'post',
    url: resourcePath + "/list",
    data: filter
  }, true);
}
/** @hidden */


function generateListEndpoint(axiosInstance, resourcePath, metadataMap, withPost, transform) {
  if (withPost === void 0) {
    withPost = true;
  }

  if (transform === void 0) {
    transform = noTransformFunction;
  }

  function addNextPageFunction(dataWithCursor, params) {
    var nextCursor = dataWithCursor.nextCursor;
    var next = nextCursor ? function () {
      return list(Object.assign({}, params, {
        cursor: nextCursor
      }));
    } : undefined;
    Object.assign(dataWithCursor, {
      next: next
    });
  }

  function list(filter) {
    return __awaiter(this, void 0, void 0, function () {
      var response, transformedResponse;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , withPost ? listByPost(axiosInstance, resourcePath, filter) : listByGet(axiosInstance, resourcePath, filter)];

          case 1:
            response = _a.sent();
            transformedResponse = {
              items: transform(response.data.items),
              nextCursor: response.data.nextCursor
            };
            addNextPageFunction(transformedResponse, filter);
            return [2
            /*return*/
            , metadataMap.addAndReturn(transformedResponse, response)];
        }
      });
    });
  }

  return function (params) {
    if (params === void 0) {
      params = {};
    }

    var listPromise = list(params);
    return Object.assign(listPromise, makeAutoPaginationMethods(listPromise));
  };
}
/** @hidden */


function generateListNoCursorEndpoint(axiosInstance, resourcePath, metadataMap) {
  return function list() {
    return __awaiter(this, void 0, void 0, function () {
      var response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , rawRequest(axiosInstance, {
              method: 'get',
              url: resourcePath
            }, true)];

          case 1:
            response = _a.sent();
            return [2
            /*return*/
            , metadataMap.addAndReturn(response.data.items, response)];
        }
      });
    });
  };
}
/** @hidden */


function generateListNoCursorEndpointWithQueryParams(axiosInstance, resourcePath, metadataMap) {
  return function list(params) {
    return __awaiter(this, void 0, void 0, function () {
      var response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , rawRequest(axiosInstance, {
              method: 'get',
              url: resourcePath,
              params: params
            }, true)];

          case 1:
            response = _a.sent();
            return [2
            /*return*/
            , metadataMap.addAndReturn(response.data.items, response)];
        }
      });
    });
  };
}
/** @hidden */


function generateSimpleListEndpoint(axiosInstance, resourcePath, metadataMap) {
  return function list(filter) {
    return __awaiter(this, void 0, void 0, function () {
      var response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , rawRequest(axiosInstance, {
              method: 'post',
              url: resourcePath + "/list",
              data: filter
            }, true)];

          case 1:
            response = _a.sent();
            return [2
            /*return*/
            , metadataMap.addAndReturn(response.data.items, response)];
        }
      });
    });
  };
}
/** @hidden */


function generateRetrieveEndpoint(axiosInstance, resourcePath, metadataMap, transform, chunkFunction) {
  if (transform === void 0) {
    transform = noTransformFunction;
  }

  return function retrieve(ids) {
    return __awaiter(this, void 0, void 0, function () {
      var chunks, responses, mergedResponses;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            chunks = doChunking(ids, chunkFunction);
            return [4
            /*yield*/
            , promiseAllWithData(chunks, function (input) {
              return rawRequest(axiosInstance, {
                method: 'post',
                url: resourcePath + "/byids",
                data: {
                  items: input
                }
              }, true);
            }, false)];

          case 1:
            responses = _a.sent();
            mergedResponses = lodash.concat.apply(void 0, __spread([[]], responses.map(function (response) {
              return response.data.items;
            })));
            return [2
            /*return*/
            , metadataMap.addAndReturn(transform(mergedResponses), responses[0])];
        }
      });
    });
  };
}
/** @hidden */


function generateRetrieveSingleEndpoint(axiosInstance, resourcePath, metadataMap) {
  return function retrieveSingle(id) {
    return __awaiter(this, void 0, void 0, function () {
      var response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , rawRequest(axiosInstance, {
              url: "" + resourcePath + (id ? '/' + encodeURIComponent('' + id) : ''),
              method: 'get'
            })];

          case 1:
            response = _a.sent();
            return [2
            /*return*/
            , metadataMap.addAndReturn(response.data, response)];
        }
      });
    });
  };
}
/** @hidden */


function generateDeleteEndpoint(axiosInstance, resourcePath, metadataMap, chunkFunction) {
  return function remove(ids) {
    return __awaiter(this, void 0, void 0, function () {
      var chunks, responses;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            chunks = doChunking(ids, chunkFunction);
            return [4
            /*yield*/
            , promiseAllWithData(chunks, function (input) {
              return rawRequest(axiosInstance, {
                method: 'post',
                url: resourcePath + "/delete",
                data: {
                  items: input
                }
              });
            }, true)];

          case 1:
            responses = _a.sent();
            return [2
            /*return*/
            , metadataMap.addAndReturn({}, responses[0])];
        }
      });
    });
  };
}
/** @hidden */


function generateDeleteEndpointWithParams(axiosInstance, resourcePath, metadataMap, chunkFunction) {
  return function remove(ids, params) {
    return __awaiter(this, void 0, void 0, function () {
      var chunks, responses;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            chunks = doChunking(ids, chunkFunction);
            return [4
            /*yield*/
            , promiseAllWithData(chunks, function (input) {
              return rawRequest(axiosInstance, {
                method: 'post',
                url: resourcePath + "/delete",
                data: _assign({}, params || {}, {
                  items: input
                })
              });
            }, true)];

          case 1:
            responses = _a.sent();
            return [2
            /*return*/
            , metadataMap.addAndReturn({}, responses[0])];
        }
      });
    });
  };
}
/** @hidden */


function generateUpdateEndpoint(axiosInstance, resourcePath, metadataMap, transform, chunkFunction) {
  if (transform === void 0) {
    transform = noTransformFunction;
  }

  return function update(changes) {
    return __awaiter(this, void 0, void 0, function () {
      var chunks, responses, mergedResponses;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            chunks = doChunking(changes, chunkFunction);
            return [4
            /*yield*/
            , promiseAllWithData(chunks, function (input) {
              return rawRequest(axiosInstance, {
                method: 'post',
                url: resourcePath + "/update",
                data: {
                  items: input
                }
              });
            }, false)];

          case 1:
            responses = _a.sent();
            mergedResponses = lodash.concat.apply(void 0, __spread([[]], responses.map(function (response) {
              return response.data.items;
            })));
            return [2
            /*return*/
            , metadataMap.addAndReturn(transform(mergedResponses), responses[0])];
        }
      });
    });
  };
}
/** @hidden */


function generateSearchEndpoint(axiosInstance, resourcePath, metadataMap, transform) {
  if (transform === void 0) {
    transform = noTransformFunction;
  }

  return function search(query) {
    return __awaiter(this, void 0, void 0, function () {
      var response, items;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , rawRequest(axiosInstance, {
              method: 'post',
              url: resourcePath + "/search",
              data: query
            }, true)];

          case 1:
            response = _a.sent();
            items = response.data.items;
            return [2
            /*return*/
            , metadataMap.addAndReturn(transform(items), response)];
        }
      });
    });
  };
}
/** @hidden */


function generateRetrieveLatestEndpoint(axiosInstance, resourcePath, metadataMap) {
  return function retrieveLatest(query) {
    return __awaiter(this, void 0, void 0, function () {
      var response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , rawRequest(axiosInstance, {
              method: 'post',
              url: resourcePath + "/latest",
              data: {
                items: query
              }
            }, true)];

          case 1:
            response = _a.sent();
            return [2
            /*return*/
            , metadataMap.addAndReturn(response.data.items, response)];
        }
      });
    });
  };
}
/** @hidden */


function generateInsertEndpoint(axiosInstance, resourcePath, metadataMap, chunkFunction) {
  return function insert(items) {
    return __awaiter(this, void 0, void 0, function () {
      var chunks, responses;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            chunks = doChunking(items, chunkFunction);
            return [4
            /*yield*/
            , promiseAllWithData(chunks, function (input) {
              return rawRequest(axiosInstance, {
                method: 'post',
                url: resourcePath,
                data: {
                  items: input
                }
              });
            }, true)];

          case 1:
            responses = _a.sent();
            return [2
            /*return*/
            , metadataMap.addAndReturn({}, responses[0])];
        }
      });
    });
  };
}
/** @hidden */


function generateSingleReplaceEndpoint(axiosInstance, resourcePath, metadataMap) {
  return function replace(replacement) {
    return __awaiter(this, void 0, void 0, function () {
      var response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , rawRequest(axiosInstance, {
              method: 'put',
              url: resourcePath,
              data: replacement
            }, true)];

          case 1:
            response = _a.sent();
            return [2
            /*return*/
            , metadataMap.addAndReturn(response.data, response)];
        }
      });
    });
  };
}

function doChunking(items, chunkFunction) {
  var chunks = [[]];

  if (items.length) {
    chunks = chunkFunction ? chunkFunction(items) : lodash.chunk(items, 1000);
  }

  return chunks;
} // Copyright 2019 Cognite AS


var AssetMappings3DAPI =
/** @class */
function () {
  /** @hidden */
  function AssetMappings3DAPI(project, instance, map) {
    var _this = this;
    /**
     * [List 3D asset mappings](https://doc.cognitedata.com/api/v1/#operation/get3DMappings)
     *
     * ```js
     * const mappings3D = await client.assetMappings3D.list();
     * ```
     */


    this.list = function (modelId, revisionId, filter) {
      return generateListEndpoint(_this.instance, parameterizePath(_this.project, modelId, revisionId), _this.map, false)(filter);
    };
    /**
     * [Create 3D asset mappings](https://doc.cognitedata.com/api/v1/#operation/create3DMappings)
     *
     * ```js
     * const assetMappingsToCreate = [
     *  {
     *    nodeId: 8252999965991682
     *    assetId: 4354399876978078
     *  },
     *  {
     *    nodeId: 9034285498543958
     *    assetId: 1042345809544395
     *  }
     * ];
     * const mappings3D = await client.assetMappings3D.create(
     *  25432542356436,
     *  33485743958747,
     *  assetMappingsToCreate
     * );
     * ```
     */


    this.create = function (modelId, revisionId, items) {
      return generateCreateEndpoint(_this.instance, parameterizePath(_this.project, modelId, revisionId), _this.map)(items);
    };
    /**
     * [Delete a list of asset mappings](https://doc.cognitedata.com/api/v1/#operation/delete3DMappings)
     *
     * ```js
     * const assetMappingsToDelete = [
     *  {
     *    nodeId: 8252999965991682
     *    assetId: 4354399876978078
     *  },
     *  {
     *    nodeId: 9034285498543958
     *    assetId: 1042345809544395
     *  }
     * ];
     * await client.assetMappings3D.delete(8252999965991682, 4190022127342195, assetMappingsToDelete);
     * ```
     */


    this.delete = function (modelId, revisionId, items) {
      return generateDeleteEndpoint(_this.instance, parameterizePath(_this.project, modelId, revisionId), _this.map)(items);
    };

    this.project = project;
    this.instance = instance;
    this.map = map;
  }

  return AssetMappings3DAPI;
}();

function parameterizePath(project, modelId, revisionId) {
  return projectUrl(project) + "/3d/models/" + modelId + "/revisions/" + revisionId + "/mappings";
} // Copyright 2019 Cognite AS


var Files3DAPI =
/** @class */
function () {
  /** @hidden */
  function Files3DAPI(project, instance, map) {
    var _this = this;
    /**
     * [Retrieve a 3D file"](https://doc.cognitedata.com/api/v1/#operation/get3DFile)
     *
     * ```js
     * await client.files3D.retrieve(3744350296805509);
     * ```
     */


    this.retrieve = function (file3DId) {
      return __awaiter(_this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , rawRequest(this.instance, {
                url: this.path + "/" + encodeURIComponent('' + file3DId),
                method: 'get',
                responseType: 'arraybuffer'
              })];

            case 1:
              response = _a.sent();
              return [2
              /*return*/
              , this.map.addAndReturn(response.data, response)];
          }
        });
      });
    };

    this.path = projectUrl(project) + '/3d/files';
    this.instance = instance;
    this.map = map;
  }

  return Files3DAPI;
}(); // Copyright 2019 Cognite AS


var Models3DAPI =
/** @class */
function () {
  /** @hidden */
  function Models3DAPI(project, instance, map) {
    var path = projectUrl(project) + '/3d/models';
    this.list = generateListEndpoint(instance, path, map, false);
    this.create = generateCreateEndpoint(instance, path, map);
    this.update = generateUpdateEndpoint(instance, path, map);
    this.delete = generateDeleteEndpoint(instance, path, map);
    this.retrieve = generateRetrieveSingleEndpoint(instance, path, map);
  }

  return Models3DAPI;
}(); // Copyright 2019 Cognite AS


var Revisions3DAPI =
/** @class */
function () {
  /** @hidden */
  function Revisions3DAPI(project, instance, map) {
    var _this = this;
    /**
     * [List 3D revisions](https://doc.cognitedata.com/api/v1/#operation/get3DRevisions)
     *
     * ```js
     * const revisions3D = await client.revisions3D.list();
     * ```
     */


    this.list = function (modelId, filter) {
      return generateListEndpoint(_this.instance, parameterizePath$1(_this.project, modelId), _this.map, false)(filter);
    };
    /**
     * [Create 3D revisions](https://doc.cognitedata.com/api/v1/#operation/create3DRevisions)
     *
     * ```js
     * const revisions = await client.revisions3D.create(model.id, [{ fileId: 8252999965991682 }, { fileId: 6305529564379596 }]);
     * ```
     */


    this.create = function (modelId, items) {
      return generateCreateEndpoint(_this.instance, parameterizePath$1(_this.project, modelId), _this.map)(items);
    };
    /**
     * [Update 3D revisions](https://doc.cognitedata.com/api/v1/#operation/update3DRevisions)
     *
     * ```js
     * const revisionsToUpdate = [{
     *  id: 6305529564379596,
     *  update: {
     *    rotation: {
     *      set: [1, 2, 3]
     *    }
     *  }
     * }]
     * const updated = await client.revisions3D.update(8252999965991682, revisionsToUpdate);
     * ```
     */


    this.update = function (modelId, items) {
      return generateUpdateEndpoint(_this.instance, parameterizePath$1(_this.project, modelId), _this.map)(items);
    };
    /**
     * [Delete 3D revisions](https://doc.cognitedata.com/api/v1/#operation/delete3DRevisions)
     *
     * ```js
     * await client.revisions3D.delete(8252999965991682, [{ id: 4190022127342195 }]);
     * ```
     */


    this.delete = function (modelId, ids) {
      return generateDeleteEndpoint(_this.instance, parameterizePath$1(_this.project, modelId), _this.map)(ids);
    };
    /**
     * [Retrieve a 3D revision](https://doc.cognitedata.com/api/v1/#operation/get3DRevision)
     *
     * ```js
     * const revisions3D = await client.revisions3D.retrieve(8252999965991682, 4190022127342195)
     * ```
     */


    this.retrieve = function (modelId, revisionId) {
      return generateRetrieveSingleEndpoint(_this.instance, parameterizePath$1(_this.project, modelId), _this.map)(revisionId);
    };

    this.updateThumbnail = function (modelId, revisionId, fileId) {
      return __awaiter(_this, void 0, void 0, function () {
        var resourcePath, response;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              resourcePath = parameterizePath$1(this.project, modelId) + "/" + revisionId;
              return [4
              /*yield*/
              , rawRequest(this.instance, {
                method: 'post',
                url: resourcePath + "/thumbnail",
                data: {
                  fileId: fileId
                }
              }, true)];

            case 1:
              response = _a.sent();
              return [2
              /*return*/
              , this.map.addAndReturn({}, response)];
          }
        });
      });
    };
    /**
     * [List 3D nodes](https://doc.cognitedata.com/api/v1/#operation/get3DNodes)
     *
     * ```js
     * const nodes3d = await client.revisions3D.list3DNodes(8252999965991682, 4190022127342195);
     * ```
     */


    this.list3DNodes = function (modelId, revisionId, query) {
      return generateListEndpoint(_this.instance, parameterizePath$1(_this.project, modelId, revisionId), _this.map, false)(query);
    };
    /**
     * [List 3D ancestor nodes](https://doc.cognitedata.com/api/v1/#operation/get3DNodeAncestors)
     *
     * ```js
     * const nodes3d = await client.revisions3D.list3DNodes(8252999965991682, 4190022127342195, 572413075141081);
     * ```
     */


    this.list3DNodeAncestors = function (modelId, revisionId, nodeId, query) {
      return generateListEndpoint(_this.instance, parameterizePath$1(_this.project, modelId, revisionId, nodeId), _this.map, false)(query);
    };

    this.project = project;
    this.instance = instance;
    this.map = map;
  }

  return Revisions3DAPI;
}();

function parameterizePath$1(project, modelId, revisionId, nodeId) {
  var url = projectUrl(project) + "/3d/models/" + modelId + "/revisions";

  if (revisionId) {
    url += "/" + revisionId + "/nodes";

    if (nodeId) {
      url += "/" + nodeId + "/ancestors";
    }
  }

  return url;
} // Copyright 2019 Cognite AS


var Viewer3DAPI =
/** @class */
function () {
  /** @hidden */
  function Viewer3DAPI(project, instance, map) {
    var _this = this;
    /**
     * [Retrieve a 3D revision (Reveal)](https://doc.cognitedata.com/api/v1/#operation/getReveal3DRevision)
     *
     * ```js
     * const revisionReveal = await client.viewer3D.retrieveRevealRevision3D(294879032167592, 3247239473298342)
     * ```
     */


    this.retrieveRevealRevision3D = function (modelId, revisionId) {
      return generateRetrieveSingleEndpoint(_this.instance, parameterizePath$2(_this.project, modelId, revisionId), _this.map)();
    };
    /**
     * [List 3D nodes (Reveal)](https://doc.cognitedata.com/api/v1/#operation/revealGet3DNodes)
     *
     * ```js
     * const nodes3dReveal = await client.viewer3D
     *  .listRevealNodes3D(8252999965991682, 4190022127342195)
     *  .autoPagingToArray();
     * ```
     */


    this.listRevealNodes3D = function (modelId, revisionId, query) {
      return generateListEndpoint(_this.instance, parameterizePath$2(_this.project, modelId, revisionId) + '/nodes', _this.map, false)(query);
    };
    /**
     * [List 3D ancestor nodes (Reveal)](https://doc.cognitedata.com/api/v1/#operation/revealGet3DNodeAncestors)
     *
     * ```js
     * const ancestorsReveal = await client.viewer3D
     *  .listRevealNode3DAncestors(8252999965991682, 4190022127342195, 120982398890213)
     *  .autoPagingToArray();
     * ```
     */


    this.listRevealNode3DAncestors = function (modelId, revisionId, nodeId, query) {
      return generateListEndpoint(_this.instance, parameterizePath$2(_this.project, modelId, revisionId) + ("/nodes/" + nodeId), _this.map, false)(query);
    };
    /**
     * [List 3D sectors (Reveal)](https://doc.cognitedata.com/api/v1/#operation/revealGet3DSectors)
     *
     * ```js
     * const sectors3D = await client.viewer3D.revisions3D
     *  .listRevealSectors3D(8252999965991682, 4190022127342195, { limit: 10 })
     *  .autoPagingToArray();
     * ```
     */


    this.listRevealSectors3D = function (modelId, revisionId, query) {
      return generateListEndpoint(_this.instance, parameterizePath$2(_this.project, modelId, revisionId) + "/sectors", _this.map, false)(query);
    };
    /**
     * [Retrieve a 3D revision (Unreal)](https://doc.cognitedata.com/api/v1/#operation/getUnreal3DRevision)
     *
     * ```js
     * const revisions3DUnreal = await client.viewer3D.retrieveUnrealRevision3D(8252999965991682, 4190022127342195);
     * ```
     */


    this.retrieveUnrealRevision3D = function (modelId, revisionId) {
      return generateRetrieveSingleEndpoint(_this.instance, parameterizePath$2(_this.project, modelId, revisionId, true), _this.map)();
    };

    this.project = project;
    this.instance = instance;
    this.map = map;
  }

  return Viewer3DAPI;
}();

function parameterizePath$2(project, modelId, revisionId, unreal) {
  if (unreal === void 0) {
    unreal = false;
  }

  var type3D = unreal ? 'unreal' : 'reveal';
  return projectUrl(project) + "/3d/" + type3D + "/models/" + modelId + "/revisions/" + revisionId;
} // Copyright 2019 Cognite AS


var ApiKeysAPI =
/** @class */
function () {
  /** @hidden */
  function ApiKeysAPI(project, instance, map) {
    var path = projectUrl(project) + '/apikeys';
    this.create = generateCreateEndpoint(instance, path, map);
    this.list = generateListNoCursorEndpointWithQueryParams(instance, path, map);
    this.delete = generateDeleteEndpoint(instance, path, map);
  }

  return ApiKeysAPI;
}(); // Copyright 2019 Cognite AS


var TimeSeriesAPI =
/** @class */
function () {
  /** @hidden */
  function TimeSeriesAPI(project, instance, map) {
    var path = projectUrl(project) + '/timeseries';
    this.create = generateCreateEndpoint(instance, path, map);
    this.list = generateListEndpoint(instance, path, map, false);
    this.search = generateSearchEndpoint(instance, path, map);
    this.retrieve = generateRetrieveEndpoint(instance, path, map);
    this.update = generateUpdateEndpoint(instance, path, map);
    this.delete = generateDeleteEndpoint(instance, path, map);
  }

  return TimeSeriesAPI;
}(); // Copyright 2019 Cognite AS


var AssetList =
/** @class */
function (_super) {
  __extends(AssetList, _super);

  function AssetList(client, items) {
    var _this = _super.apply(this, __spread(items)) || this;
    /**
     * Deletes all assets in the AssetList
     * ```js
     * await assetList.delete();
     * ```
     */


    _this.delete = function () {
      return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
          return [2
          /*return*/
          , this.client.assets.delete(this.map(function (asset) {
            return {
              id: asset.id
            };
          }))];
        });
      });
    };
    /**
     * Return all timeseries for assets in the AssetList
     * ```js
     * const timeseries = await assetList.timeSeries();
     * ```
     */


    _this.timeSeries = function () {
      return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , this.getResourcesFromAssets(this.client.timeseries)];

            case 1:
              return [2
              /*return*/
              , _a.sent()];
          }
        });
      });
    };
    /**
     * Return all files for assets in the AssetList
     * ```js
     * const files = await assetList.files();
     * ```
     */


    _this.files = function () {
      return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , this.getResourcesFromAssets(this.client.files)];

            case 1:
              return [2
              /*return*/
              , _a.sent()];
          }
        });
      });
    };
    /**
     * Return all events for assets in the AssetList
     * ```js
     * const events = await assetList.events();
     * ```
     */


    _this.events = function () {
      return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , this.getResourcesFromAssets(this.client.events)];

            case 1:
              return [2
              /*return*/
              , _a.sent()];
          }
        });
      });
    };

    _this.getResourcesFromAssets = function (accessedApi) {
      return __awaiter(_this, void 0, void 0, function () {
        var e_1, _a, chunks, promises, chunks_1, chunks_1_1, idArray, assetIds, results, responses;

        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              chunks = this.toChunkedArrayOfIds();
              promises = [];

              try {
                for (chunks_1 = __values(chunks), chunks_1_1 = chunks_1.next(); !chunks_1_1.done; chunks_1_1 = chunks_1.next()) {
                  idArray = chunks_1_1.value;
                  assetIds = {
                    assetIds: idArray
                  };

                  if (accessedApi instanceof TimeSeriesAPI) {
                    promises.push(accessedApi.list(assetIds).autoPagingToArray({
                      limit: Infinity
                    }));
                  } else {
                    promises.push(accessedApi.list({
                      filter: assetIds
                    }).autoPagingToArray({
                      limit: Infinity
                    }));
                  }
                }
              } catch (e_1_1) {
                e_1 = {
                  error: e_1_1
                };
              } finally {
                try {
                  if (chunks_1_1 && !chunks_1_1.done && (_a = chunks_1.return)) _a.call(chunks_1);
                } finally {
                  if (e_1) throw e_1.error;
                }
              }

              return [4
              /*yield*/
              , Promise.all(promises)];

            case 1:
              results = _b.sent();
              responses = [];
              results.forEach(function (result) {
                responses.push.apply(responses, __spread(result));
              });
              return [2
              /*return*/
              , responses];
          }
        });
      });
    };

    _this.toChunkedArrayOfIds = function () {
      var ids = _this.map(function (asset) {
        return asset.id;
      });

      var chunks = [[]];

      if (ids.length) {
        chunks = lodash.chunk(ids, 100);
      }

      return chunks;
    };

    _this.client = client;
    return _this;
  }

  return AssetList;
}(Array); // Copyright 2019 Cognite AS


var Asset =
/** @class */
function () {
  function Asset(client, props) {
    var _this = this;
    /**
     * Deletes the current asset
     *
     * @param {DeleteOptions} options Allow to delete recursively, default ({}) is recursive = false
     * ```js
     * await asset.delete();
     * ```
     */


    this.delete = function (options) {
      if (options === void 0) {
        options = {};
      }

      return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
          return [2
          /*return*/
          , this.client.assets.delete([{
            id: this.id
          }], options)];
        });
      });
    };
    /**
     * Retrieves the parent of the current asset
     * ```js
     * const parentAsset = await asset.parent();
     * ```
     */


    this.parent = function () {
      return __awaiter(_this, void 0, void 0, function () {
        var _a, parentAsset;

        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              if (!this.parentId) return [3
              /*break*/
              , 2];
              return [4
              /*yield*/
              , this.client.assets.retrieve([{
                id: this.parentId
              }])];

            case 1:
              _a = __read.apply(void 0, [_b.sent(), 1]), parentAsset = _a[0];
              return [2
              /*return*/
              , parentAsset];

            case 2:
              return [2
              /*return*/
              , null];
          }
        });
      });
    };
    /**
     * Returns an AssetList object with all children of the current asset
     * ```js
     * const children = await asset.children();
     * ```
     */


    this.children = function () {
      return __awaiter(_this, void 0, void 0, function () {
        var childAssets;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , this.client.assets.list({
                filter: {
                  parentIds: [this.id]
                }
              }).autoPagingToArray({
                limit: Infinity
              })];

            case 1:
              childAssets = _a.sent();
              return [2
              /*return*/
              , new AssetList(this.client, childAssets)];
          }
        });
      });
    };
    /**
     * Returns the full subtree of the current asset, including the asset itself
     * @param {SubtreeOptions} options Specify the depth of the required subtree, default is the whole asset-hierarchy
     * ```js
     * const subtree = await asset.subtree();
     * ```
     */


    this.subtree = function (options) {
      return __awaiter(_this, void 0, void 0, function () {
        var query;
        return __generator(this, function (_a) {
          query = options || {};
          return [2
          /*return*/
          , this.client.assets.retrieveSubtree({
            id: this.id
          }, query.depth || Infinity)];
        });
      });
    };
    /**
     * Returns all timeseries for the current asset
     * @param {TimeseriesFilter} filter Allow specified filter for what timeseries to retrieve
     * ```js
     * const timeSeries = await asset.timeSeries();
     * ```
     */


    this.timeSeries = function (filter) {
      if (filter === void 0) {
        filter = {};
      }

      return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
          return [2
          /*return*/
          , this.client.timeseries.list(_assign({}, filter, {
            assetIds: [this.id]
          })).autoPagingToArray({
            limit: Infinity
          })];
        });
      });
    };
    /**
     * Returns all events for the current asset
     * @param {EventFilter} filter Allow specified filter for what events to retrieve
     * ```js
     * const events = await asset.events();
     * ```
     */


    this.events = function (filter) {
      if (filter === void 0) {
        filter = {};
      }

      return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
          return [2
          /*return*/
          , this.client.events.list({
            filter: _assign({}, filter, {
              assetIds: [this.id]
            })
          }).autoPagingToArray({
            limit: Infinity
          })];
        });
      });
    };
    /**
     * Returns all files for the current asset
     * @param {FileFilter} filter Allow specified filter for what files to retrieve
     * ```js
     * const files = await asset.files();
     * ```
     */


    this.files = function (filter) {
      if (filter === void 0) {
        filter = {};
      }

      return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
          return [2
          /*return*/
          , this.client.files.list({
            filter: _assign({}, filter, {
              assetIds: [this.id]
            })
          }).autoPagingToArray({
            limit: Infinity
          })];
        });
      });
    };

    this.client = client;
    this.id = props.id;
    this.externalId = props.externalId;
    this.parentId = props.parentId;
    this.name = props.name;
    this.description = props.description;
    this.metadata = props.metadata;
    this.source = props.source;
    this.lastUpdatedTime = props.lastUpdatedTime;
    this.createdTime = props.createdTime;
    this.rootId = props.rootId;
  }

  return Asset;
}(); // Copyright 2019 Cognite AS


var AssetsAPI =
/** @class */
function () {
  /** @hidden */
  function AssetsAPI(client, project, instance, map) {
    var _this = this;

    this.transformToAssetListObject = function (assets) {
      var assetArray = assets.map(function (asset) {
        return new Asset(_this.client, asset);
      });
      return new AssetList(_this.client, assetArray);
    };

    this.getChildren = function (assets) {
      return __awaiter(_this, void 0, void 0, function () {
        var e_1, _a, ids, chunks, assetsArray, chunks_1, chunks_1_1, chunkOfAssetIds, childrenList, e_1_1;

        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              ids = assets.map(function (asset) {
                return asset.id;
              });
              chunks = lodash.chunk(ids, 100);
              assetsArray = [];
              _b.label = 1;

            case 1:
              _b.trys.push([1, 6, 7, 8]);

              chunks_1 = __values(chunks), chunks_1_1 = chunks_1.next();
              _b.label = 2;

            case 2:
              if (!!chunks_1_1.done) return [3
              /*break*/
              , 5];
              chunkOfAssetIds = chunks_1_1.value;
              return [4
              /*yield*/
              , this.client.assets.list({
                filter: {
                  parentIds: chunkOfAssetIds
                }
              }).autoPagingToArray({
                limit: Infinity
              })];

            case 3:
              childrenList = _b.sent();
              assetsArray.push.apply(assetsArray, __spread(childrenList));
              _b.label = 4;

            case 4:
              chunks_1_1 = chunks_1.next();
              return [3
              /*break*/
              , 2];

            case 5:
              return [3
              /*break*/
              , 8];

            case 6:
              e_1_1 = _b.sent();
              e_1 = {
                error: e_1_1
              };
              return [3
              /*break*/
              , 8];

            case 7:
              try {
                if (chunks_1_1 && !chunks_1_1.done && (_a = chunks_1.return)) _a.call(chunks_1);
              } finally {
                if (e_1) throw e_1.error;
              }

              return [7
              /*endfinally*/
              ];

            case 8:
              return [2
              /*return*/
              , new AssetList(this.client, assetsArray)];
          }
        });
      });
    };

    this.client = client;
    var path = projectUrl(project) + '/assets';
    var transformResponse = this.transformToAssetListObject;
    this.create = generateCreateEndpoint(instance, path, map, transformResponse, assetChunker);
    this.list = generateListEndpoint(instance, path, map, true, transformResponse);
    this.retrieve = generateRetrieveEndpoint(instance, path, map, transformResponse);
    this.update = generateUpdateEndpoint(instance, path, map, transformResponse);
    this.search = generateSearchEndpoint(instance, path, map, transformResponse);
    this.delete = generateDeleteEndpointWithParams(instance, path, map);
  }

  AssetsAPI.prototype.retrieveSubtree = function (id, depth) {
    return __awaiter(this, void 0, void 0, function () {
      var currentDepth, rootAssetList;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            currentDepth = 0;
            return [4
            /*yield*/
            , this.retrieve([id])];

          case 1:
            rootAssetList = _a.sent();
            return [2
            /*return*/
            , this.getAssetSubtree(rootAssetList, currentDepth, depth)];
        }
      });
    });
  };

  AssetsAPI.prototype.getAssetSubtree = function (assets, currentDepth, depth) {
    if (depth === void 0) {
      depth = Infinity;
    }

    return __awaiter(this, void 0, void 0, function () {
      var subtree, children, subtreeOfChildren;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            subtree = assets;
            if (!(depth > currentDepth)) return [3
            /*break*/
            , 3];
            return [4
            /*yield*/
            , this.getChildren(assets)];

          case 1:
            children = _a.sent();
            if (!(children.length !== 0)) return [3
            /*break*/
            , 3];
            return [4
            /*yield*/
            , this.getAssetSubtree(children, currentDepth + 1, depth)];

          case 2:
            subtreeOfChildren = _a.sent();
            subtree.push.apply(subtree, __spread(subtreeOfChildren));
            _a.label = 3;

          case 3:
            return [2
            /*return*/
            , subtree];
        }
      });
    });
  };

  return AssetsAPI;
}(); // Copyright 2019 Cognite AS


var DataPointsAPI =
/** @class */
function () {
  /** @hidden */
  function DataPointsAPI(project, instance, map) {
    var path = projectUrl(project) + '/timeseries/data';
    this.insert = generateInsertEndpoint(instance, path, map);
    this.retrieve = generateSimpleListEndpoint(instance, path, map);
    this.retrieveLatest = generateRetrieveLatestEndpoint(instance, path, map);
    this.delete = generateDeleteEndpoint(instance, path, map);
  }

  return DataPointsAPI;
}(); // Copyright 2019 Cognite AS


var EventsAPI =
/** @class */
function () {
  /** @hidden */
  function EventsAPI(project, instance, map) {
    var path = projectUrl(project) + '/events';
    this.create = generateCreateEndpoint(instance, path, map);
    this.list = generateListEndpoint(instance, path, map, true);
    this.retrieve = generateRetrieveEndpoint(instance, path, map);
    this.update = generateUpdateEndpoint(instance, path, map);
    this.search = generateSearchEndpoint(instance, path, map);
    this.delete = generateDeleteEndpoint(instance, path, map);
  }

  return EventsAPI;
}(); // Copyright 2019 Cognite AS

/** @hidden */


function waitUntilFileIsUploaded(fileId, axiosInstance, resourcePath, frequencyInMs, maxTime) {
  var _this = this;

  if (frequencyInMs === void 0) {
    frequencyInMs = 1000;
  }

  if (maxTime === void 0) {
    maxTime = 2 * 60 * 1000;
  }

  return new Promise(function (resolve, reject) {
    try {
      var retrieve_1 = generateRetrieveSingleEndpoint(axiosInstance, resourcePath, new MetadataMap());
      var startTime_1 = Date.now();
      var myInterval_1 = setInterval(function () {
        return __awaiter(_this, void 0, void 0, function () {
          var now, fileInfo;
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                now = Date.now();

                if (now - startTime_1 > maxTime) {
                  clearInterval(myInterval_1);
                  reject(new Error("File never marked as 'uploaded'"));
                }

                return [4
                /*yield*/
                , retrieve_1(fileId)];

              case 1:
                fileInfo = _a.sent();

                if (fileInfo.uploaded) {
                  clearInterval(myInterval_1);
                  resolve(fileInfo);
                }

                return [2
                /*return*/
                ];
            }
          });
        });
      }, frequencyInMs);
    } catch (e) {
      reject(e);
    }
  });
}
/** @hidden */


function generateUploadEndpoint(axiosInstance, resourcePath, metadataMap) {
  return function upload(fileMetadata, fileContent, overwrite, waitUntilAcknowledged) {
    if (overwrite === void 0) {
      overwrite = false;
    }

    if (waitUntilAcknowledged === void 0) {
      waitUntilAcknowledged = false;
    }

    return __awaiter(this, void 0, void 0, function () {
      var params, response, file, uploadUrl, headers, fileInfo;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            params = {};

            if (overwrite) {
              params.overwrite = true;
            }

            return [4
            /*yield*/
            , rawRequest(axiosInstance, {
              method: 'post',
              url: resourcePath,
              data: fileMetadata,
              params: params
            })];

          case 1:
            response = _a.sent();
            file = response.data;
            if (!(fileContent != null)) return [3
            /*break*/
            , 3];
            uploadUrl = file.uploadUrl;
            headers = {};

            if (fileMetadata.mimeType != null) {
              headers['Content-Type'] = fileMetadata.mimeType;
            }

            return [4
            /*yield*/
            , rawRequest(axiosInstance, {
              method: 'put',
              url: uploadUrl,
              headers: headers,
              data: fileContent
            })];

          case 2:
            _a.sent();

            _a.label = 3;

          case 3:
            if (!waitUntilAcknowledged) return [3
            /*break*/
            , 5];
            return [4
            /*yield*/
            , waitUntilFileIsUploaded(file.id, axiosInstance, resourcePath)];

          case 4:
            fileInfo = _a.sent();
            return [2
            /*return*/
            , metadataMap.addAndReturn(fileInfo, response)];

          case 5:
            return [2
            /*return*/
            , metadataMap.addAndReturn(file, response)];
        }
      });
    });
  };
}
/** @hidden */


function generateDownloadUrlEndpoint(axiosInstance, resourcePath, metadataMap) {
  return function downloadUrl(items) {
    return __awaiter(this, void 0, void 0, function () {
      var response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , rawRequest(axiosInstance, {
              method: 'post',
              url: resourcePath + "/downloadlink",
              data: {
                items: items
              }
            }, true)];

          case 1:
            response = _a.sent();
            return [2
            /*return*/
            , metadataMap.addAndReturn(response.data.items, response)];
        }
      });
    });
  };
} // Copyright 2019 Cognite AS


var FilesAPI =
/** @class */
function () {
  /** @hidden */
  function FilesAPI(project, instance, map) {
    var path = projectUrl(project) + '/files';
    this.list = generateListEndpoint(instance, path, map, true);
    this.upload = generateUploadEndpoint(instance, path, map);
    this.retrieve = generateRetrieveEndpoint(instance, path, map);
    this.search = generateSearchEndpoint(instance, path, map);
    this.delete = generateDeleteEndpoint(instance, path, map);
    this.getDownloadUrls = generateDownloadUrlEndpoint(instance, path, map);
    this.update = generateUpdateEndpoint(instance, path, map);
  }

  return FilesAPI;
}(); // Copyright 2019 Cognite AS


var GroupsAPI =
/** @class */
function () {
  /** @hidden */
  function GroupsAPI(project, instance, map) {
    var _this = this;
    /**
     * [List service accounts in a group](https://doc.cognitedata.com/api/v1/#operation/getMembersOfGroups)
     *
     * ```js
     * const serviceAccounts = await client.groups.listServiceAccounts(921923342342323);
     * ```
     */


    this.listServiceAccounts = function (groupId) {
      return generateListNoCursorEndpoint(_this.instance, _this.serviceAccountPath(groupId), _this.map)();
    };
    /**
     * [Add service accounts to a group](https://doc.cognitedata.com/api/v1/#operation/addServiceAccountsToGroup)
     *
     * ```js
     * await client.groups.addServiceAccounts(921923342342323, [123312763989213, 23232789217132]);
     * ```
     */


    this.addServiceAccounts = function (groupId, serviceAccountIds) {
      return __awaiter(_this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , rawRequest(this.instance, {
                url: this.serviceAccountPath(groupId),
                method: 'post',
                data: {
                  items: serviceAccountIds
                }
              }, true)];

            case 1:
              response = _a.sent();
              return [2
              /*return*/
              , this.map.addAndReturn({}, response)];
          }
        });
      });
    };
    /**
     * [Remove service accounts from a group](https://doc.cognitedata.com/api/v1/#operation/removeServiceAccountsFromGroup)
     *
     * ```js
     * await client.groups.removeServiceAccounts(921923342342323, [123312763989213, 23232789217132]);
     * ```
     */


    this.removeServiceAccounts = function (groupId, serviceAccountIds) {
      return __awaiter(_this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , rawRequest(this.instance, {
                url: this.serviceAccountPath(groupId) + "/remove",
                method: 'post',
                data: {
                  items: serviceAccountIds
                }
              }, true)];

            case 1:
              response = _a.sent();
              return [2
              /*return*/
              , this.map.addAndReturn({}, response)];
          }
        });
      });
    };

    this.serviceAccountPath = function (groupId) {
      return _this.path + "/" + groupId + "/serviceaccounts";
    };

    var path = this.path = projectUrl(project) + '/groups';
    this.instance = instance;
    this.map = map;
    this.list = generateListNoCursorEndpointWithQueryParams(instance, path, map);
    this.create = generateCreateEndpoint(instance, path, map);
    this.delete = generateDeleteEndpoint(instance, path, map);
  }

  return GroupsAPI;
}(); // Copyright 2019 Cognite AS


var LoginAPI =
/** @class */
function () {
  /** @hidden */
  function LoginAPI(instance) {
    var _this = this;
    /**
     * [Check login status](https://doc.cognitedata.com/api/v1/#operation/status)
     *
     * ```js
     * const status = await client.login.status();
     * // if status === null means you are not logged in
     * ```
     */


    this.status = function () {
      return getIdInfo$$1(_this.instance, {});
    };

    this.instance = instance;
  }

  return LoginAPI;
}(); // Copyright 2019 Cognite AS


var ProjectsAPI =
/** @class */
function () {
  /** @hidden */
  function ProjectsAPI(instance, map) {
    var _this = this;
    /**
     * [Update a project](https://doc.cognitedata.com/api/v1/#operation/putProject)
     *
     * ```js
     * await client.projects.update({
     *   name: 'New project display name',
     *   defaultGroupId: 123,
     * });
     * ```
     */


    this.update = function (urlName, replacement) {
      return generateSingleReplaceEndpoint(_this.instance, projectUrl(urlName), _this.map)(replacement);
    };

    var path = apiUrl() + '/projects';
    this.instance = instance;
    this.map = map;
    this.retrieve = generateRetrieveSingleEndpoint(instance, path, map);
  }

  return ProjectsAPI;
}(); // Copyright 2019 Cognite AS


var RawAPI =
/** @class */
function () {
  /** @hidden */
  function RawAPI(project, instance, map) {
    var _this = this;
    /**
     * [List tables in database](https://doc.cognitedata.com/api/v1/#operation/getTables)
     *
     * ```js
     * const tables = await client.raw.listTables('My company');
     * ```
     */


    this.listTables = function (databaseName, query) {
      var endpoint = generateListEndpoint(_this.instance, _this.tablePath(databaseName), _this.map, false);
      return endpoint(query);
    };
    /**
     * [Create tables in a database](https://doc.cognitedata.com/api/v1/#operation/createTables)
     *
     * ```js
     * const tables = await client.raw.createTables('My company', [{ name: 'Customers' }]);
     * ```
     */


    this.createTables = function (databaseName, items, ensureParent) {
      if (ensureParent === void 0) {
        ensureParent = false;
      }

      return __awaiter(_this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , rawRequest(this.instance, {
                method: 'post',
                url: this.tablePath(databaseName),
                data: {
                  items: items
                },
                params: {
                  ensureParent: ensureParent
                }
              })];

            case 1:
              response = _a.sent();
              return [2
              /*return*/
              , this.map.addAndReturn(response.data.items, response)];
          }
        });
      });
    };
    /**
     * [Delete tables in a database](https://doc.cognitedata.com/api/v1/#operation/deleteTables)
     *
     * ```js
     * await client.raw.deleteTables('My company', [{ name: 'Customers' }]);
     * ```
     */


    this.deleteTables = function (databaseName, items) {
      var endpoint = generateDeleteEndpoint(_this.instance, _this.tablePath(databaseName), _this.map);
      return endpoint(items);
    };
    /**
     * [List rows in a table](https://doc.cognitedata.com/api/v1/#operation/getRows)
     *
     * ```js
     * await client.raw.listRows('My company', [{ name: 'Customers' }]);
     * ```
     */


    this.listRows = function (databaseName, tableName, query) {
      var endpoint = generateListEndpoint(_this.instance, _this.rowPath(databaseName, tableName), _this.map, false);

      if (query && query.onlyRowKeys) {
        // @ts-ignore - we transform it
        return endpoint({
          columns: ','
        });
      }

      if (query && query.columns) {
        // @ts-ignore - we transform it
        return endpoint({
          columns: query.columns.join(',')
        });
      }

      return endpoint();
    };
    /**
     * [Insert rows into a table](https://doc.cognitedata.com/api/v1/#operation/postRows)
     *
     * ```js
     * await client.raw.insertRows('My company', 'Customers' [{ key: 'customer1', columns: { 'First name': 'Steve', 'Last name': 'Jobs' } }]);
     * ```
     */


    this.insertRows = function (databaseName, tableName, items, ensureParent) {
      if (ensureParent === void 0) {
        ensureParent = false;
      }

      return __awaiter(_this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , rawRequest(this.instance, {
                method: 'post',
                url: this.rowPath(databaseName, tableName),
                data: {
                  items: items
                },
                params: {
                  ensureParent: ensureParent
                }
              })];

            case 1:
              response = _a.sent();
              return [2
              /*return*/
              , this.map.addAndReturn({}, response)];
          }
        });
      });
    };
    /**
     * [Retrieve a single row from a table](https://doc.cognitedata.com/api/v1/#operation/getRow)
     *
     * ```js
     * await client.raw.retrieveRow('My company', 'Customers', 'customer1');
     * ```
     */


    this.retrieveRow = function (databaseName, tableName, rowKey) {
      var endpoint = generateRetrieveSingleEndpoint(_this.instance, _this.rowPath(databaseName, tableName), _this.map);
      return endpoint(rowKey);
    };
    /**
     * [Delete rows in a table](https://doc.cognitedata.com/api/v1/#operation/deleteRows)
     *
     * ```js
     * await client.raw.deleteRows('My company', 'Customers', [{key: 'customer1'}]);
     * ```
     */


    this.deleteRows = function (databaseName, tableName, items) {
      return __awaiter(_this, void 0, void 0, function () {
        var endpoint;
        return __generator(this, function (_a) {
          endpoint = generateDeleteEndpoint(this.instance, this.rowPath(databaseName, tableName), this.map);
          return [2
          /*return*/
          , endpoint(items)];
        });
      });
    };

    this.tablePath = function (databaseName) {
      return _this.path + "/" + encodeURIComponent(databaseName) + "/tables";
    };

    this.rowPath = function (databaseName, tableName) {
      return _this.tablePath(databaseName) + "/" + encodeURIComponent(tableName) + "/rows";
    };

    this.instance = instance;
    this.map = map;
    var path = this.path = projectUrl(project) + '/raw/dbs';
    this.listDatabases = generateListEndpoint(instance, this.path, map, false);
    this.createDatabases = generateCreateEndpoint(instance, path, map);
    this.deleteDatabases = generateDeleteEndpointWithParams(instance, path, map);
  }

  return RawAPI;
}(); // Copyright 2019 Cognite AS


var SecurityCategoriesAPI =
/** @class */
function () {
  /** @hidden */
  function SecurityCategoriesAPI(project, instance, map) {
    var path = projectUrl(project) + '/securitycategories';
    this.list = generateListEndpoint(instance, path, map, false);
    this.create = generateCreateEndpoint(instance, path, map);
    this.delete = generateDeleteEndpoint(instance, path, map);
  }

  return SecurityCategoriesAPI;
}(); // Copyright 2019 Cognite AS


var ServiceAccountsAPI =
/** @class */
function () {
  /** @hidden */
  function ServiceAccountsAPI(project, instance, map) {
    var path = projectUrl(project) + '/serviceaccounts';
    this.list = generateListNoCursorEndpoint(instance, path, map);
    this.create = generateCreateEndpoint(instance, path, map);
    this.delete = generateDeleteEndpoint(instance, path, map);
  }

  return ServiceAccountsAPI;
}(); // Copyright 2019 Cognite AS


var REDIRECT = 'REDIRECT';
var POPUP = 'POPUP';

function validateAndReturnAPI(api) {
  if (api === undefined) {
    throw Error('Need to login with either loginWithApiKey or loginWithOAuth before you can use the Cognite SDK');
  }

  return api;
}

function throwReLogginError() {
  throw Error('You cannot re-login with an already logged in Cognite client instance. Try to create a new Cognite client instance instead.');
}

var CogniteClient =
/** @class */
function () {
  /**
   * Create a new SDK client
   *
   * @param options Client options
   *
   * ```js
   * import { CogniteClient } from '@cognite/sdk';
   *
   * const client = new CogniteClient({ appId: 'YOUR APPLICATION NAME' });
   *
   * // can also specify a base URL
   * const client = new CogniteClient({ ..., baseUrl: 'https://greenfield.cognitedata.com' });
   * ```
   */
  function CogniteClient(options) {
    var _this = this;

    this.project = '';
    this.hasBeenLoggedIn = false; // tslint:disable-next-line:no-identical-functions

    this.authenticate = function () {
      return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
          throw Error('You can only call authenticate after you have called loginWithOAuth');
        });
      });
    };
    /**
     * Login client with api-key
     *
     * @param options Login options
     *
     * ```js
     * import { CogniteClient } from '@cognite/sdk';
     *
     * const client = new CogniteClient({ appId: '[YOUR APP NAME]' });
     * client.loginWithApiKey({
     *   apiKey: '[API KEY]',
     *   project: '[PROJECT]',
     * });
     * // after login you can do calls with the client
     * const createdAsset = await client.assets.create([{ name: 'My first asset' }]);
     * ```
     */


    this.loginWithApiKey = function (options) {
      if (_this.hasBeenLoggedIn) {
        throwReLogginError();
      }

      if (!lodash.isObject(options)) {
        throw Error('`loginWithApiKey` is missing parameter `options`');
      }

      var project = options.project,
          apiKey = options.apiKey;
      ['project', 'apiKey'].forEach(function (property) {
        // @ts-ignore
        if (!lodash.isString(options[property])) {
          throw Error("options." + property + " is required and must be of type string");
        }
      });
      _this.project = project;
      _this.instance.defaults.headers['api-key'] = apiKey;

      _this.initAPIs();
    };
    /**
     * Login client with OAuth login flow
     * <!-- [Login with redirect](https://doc.cognitedata.com/api/v1/#operation/redirectUrl) -->
     *
     * ```js
     * import { CogniteClient, REDIRECT } from '@cognite/sdk';
     *
     * const client = new CogniteClient({ appId: '[YOUR APP NAME]' });
     *
     * client.loginWithOAuth({
     *   project: '[PROJECT]',
     *   onAuthenticate: REDIRECT // optional, REDIRECT is by default
     * });
     * // after login you can do calls with the client
     * const createdAsset = await client.assets.create([{ name: 'My first asset' }]);
     * ```
     *
     * @param options Login options
     */


    this.loginWithOAuth = function (options) {
      if (_this.hasBeenLoggedIn) {
        throwReLogginError();
      }

      if (!lodash.isObject(options)) {
        throw Error('`loginWithOAuth` is missing parameter `options`');
      }

      var project = options.project;

      if (!lodash.isString(project)) {
        throw Error('options.project is required and must be of type string');
      }

      _this.project = project;

      var onTokens = options.onTokens || function () {};

      var onAuthenticate = onAuthenticateWithRedirect;

      if (options.onAuthenticate === POPUP) {
        onAuthenticate = onAuthenticateWithPopup;
      } else if (lodash.isFunction(options.onAuthenticate)) {
        onAuthenticate = options.onAuthenticate;
      }

      var authenticate = createAuthenticateFunction$$1({
        project: project,
        axiosInstance: _this.instance,
        onAuthenticate: onAuthenticate,
        onTokens: onTokens
      });
      listenForNonSuccessStatusCode(_this.instance, 401, function (error, retry) {
        return __awaiter(_this, void 0, void 0, function () {
          var config, didAuthenticate;
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                config = error.config;

                if (config.url === '/login/status') {
                  return [2
                  /*return*/
                  , Promise.reject(error)];
                }

                return [4
                /*yield*/
                , authenticate()];

              case 1:
                didAuthenticate = _a.sent();
                return [2
                /*return*/
                , didAuthenticate ? retry() : Promise.reject(error)];
            }
          });
        });
      });

      _this.initAPIs();

      _this.authenticate = authenticate;
    };
    /**
     * To modify the base-url at any point in time
     */


    this.setBaseUrl = function (baseUrl) {
      _this.instance.defaults.baseURL = baseUrl;
    };
    /**
     * Lookup response metadata from an request using the response as the parameter
     *
     * ```js
     * const createdAsset = await client.assets.create([{ name: 'My first asset' }]);
     * const metadata = client.getMetadata(createdAsset);
     * ```
     */


    this.getMetadata = function (value) {
      return _this.metadataMap.get(value);
    };
    /**
     * Basic HTTP method for GET
     *
     * @param path The URL path
     * @param options Request options, optional
     *
     * ```js
     * const response = await client.get('/api/v1/projects/{project}/assets', { params: { limit: 50 }});
     * ```
     */


    this.get = function (path, options) {
      return _this.doRawRequest('get', path, options);
    };
    /**
     * Basic HTTP method for PUT
     *
     * @param path The URL path
     * @param options Request options, optional
     *
     * ```js
     * const response = await client.put('someUrl');
     * ```
     */


    this.put = function (path, options) {
      return _this.doRawRequest('put', path, options);
    };
    /**
     * Basic HTTP method for POST
     *
     * @param path The URL path
     * @param options Request options, optional
     *
     * ```js
     * const assets = [{ name: 'First asset' }, { name: 'Second asset' }];
     * const response = await client.post('/api/v1/projects/{project}/assets', { data: { items: assets } });
     * ```
     */


    this.post = function (path, options) {
      return _this.doRawRequest('post', path, options);
    };
    /**
     * Basic HTTP method for DELETE
     *
     * @param path The URL path
     * @param options Request options, optional
     * ```js
     * const response = await client.delete('someUrl');
     * ```
     */


    this.delete = function (path, options) {
      return _this.doRawRequest('delete', path, options);
    };
    /** @hidden */


    this.doRawRequest = function (methodType, path, options) {
      return rawRequest(_this.instance, _assign({
        method: methodType,
        url: path
      }, options)).then(responseTransformer);
    };

    this.initAPIs = function () {
      var defaultArgs = [_this.project, _this.instance, _this.metadataMap];
      _this.assetsApi = new (AssetsAPI.bind.apply(AssetsAPI, __spread([void 0, _this], defaultArgs)))();
      _this.timeSeriesApi = new (TimeSeriesAPI.bind.apply(TimeSeriesAPI, __spread([void 0], defaultArgs)))();
      _this.dataPointsApi = new (DataPointsAPI.bind.apply(DataPointsAPI, __spread([void 0], defaultArgs)))();
      _this.eventsApi = new (EventsAPI.bind.apply(EventsAPI, __spread([void 0], defaultArgs)))();
      _this.filesApi = new (FilesAPI.bind.apply(FilesAPI, __spread([void 0], defaultArgs)))();
      _this.rawApi = new (RawAPI.bind.apply(RawAPI, __spread([void 0], defaultArgs)))();
      _this.projectsApi = new ProjectsAPI(_this.instance, _this.metadataMap);
      _this.groupsApi = new (GroupsAPI.bind.apply(GroupsAPI, __spread([void 0], defaultArgs)))();
      _this.securityCategoriesApi = new (SecurityCategoriesAPI.bind.apply(SecurityCategoriesAPI, __spread([void 0], defaultArgs)))();
      _this.serviceAccountsApi = new (ServiceAccountsAPI.bind.apply(ServiceAccountsAPI, __spread([void 0], defaultArgs)))();
      _this.models3DApi = new (Models3DAPI.bind.apply(Models3DAPI, __spread([void 0], defaultArgs)))();
      _this.revisions3DApi = new (Revisions3DAPI.bind.apply(Revisions3DAPI, __spread([void 0], defaultArgs)))();
      _this.files3DApi = new (Files3DAPI.bind.apply(Files3DAPI, __spread([void 0], defaultArgs)))();
      _this.assetMappings3DApi = new (AssetMappings3DAPI.bind.apply(AssetMappings3DAPI, __spread([void 0], defaultArgs)))();
      _this.viewer3DApi = new (Viewer3DAPI.bind.apply(Viewer3DAPI, __spread([void 0], defaultArgs)))();
      _this.apiKeysApi = new (ApiKeysAPI.bind.apply(ApiKeysAPI, __spread([void 0], defaultArgs)))();
    };

    if (!lodash.isObject(options)) {
      throw Error('`CogniteClient` is missing parameter `options`');
    }

    if (!lodash.isString(options.appId)) {
      throw Error('options.appId is required and must be of type string');
    }

    var baseUrl = options.baseUrl;
    this.instance = generateAxiosInstance(getBaseUrl(baseUrl), options.appId);
    addRetryToAxiosInstance(this.instance);
    this.metadataMap = new MetadataMap();
    this.loginApi = new LoginAPI(this.instance);
  }

  Object.defineProperty(CogniteClient.prototype, "assets", {
    get: function get() {
      return validateAndReturnAPI(this.assetsApi);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(CogniteClient.prototype, "timeseries", {
    get: function get() {
      return validateAndReturnAPI(this.timeSeriesApi);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(CogniteClient.prototype, "datapoints", {
    get: function get() {
      return validateAndReturnAPI(this.dataPointsApi);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(CogniteClient.prototype, "events", {
    get: function get() {
      return validateAndReturnAPI(this.eventsApi);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(CogniteClient.prototype, "files", {
    get: function get() {
      return validateAndReturnAPI(this.filesApi);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(CogniteClient.prototype, "raw", {
    get: function get() {
      return validateAndReturnAPI(this.rawApi);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(CogniteClient.prototype, "projects", {
    get: function get() {
      return validateAndReturnAPI(this.projectsApi);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(CogniteClient.prototype, "groups", {
    get: function get() {
      return validateAndReturnAPI(this.groupsApi);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(CogniteClient.prototype, "securityCategories", {
    get: function get() {
      return validateAndReturnAPI(this.securityCategoriesApi);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(CogniteClient.prototype, "serviceAccounts", {
    get: function get() {
      return validateAndReturnAPI(this.serviceAccountsApi);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(CogniteClient.prototype, "models3D", {
    get: function get() {
      return validateAndReturnAPI(this.models3DApi);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(CogniteClient.prototype, "revisions3D", {
    get: function get() {
      return validateAndReturnAPI(this.revisions3DApi);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(CogniteClient.prototype, "files3D", {
    get: function get() {
      return validateAndReturnAPI(this.files3DApi);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(CogniteClient.prototype, "assetMappings3D", {
    get: function get() {
      return validateAndReturnAPI(this.assetMappings3DApi);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(CogniteClient.prototype, "viewer3D", {
    get: function get() {
      return validateAndReturnAPI(this.viewer3DApi);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(CogniteClient.prototype, "apiKeys", {
    get: function get() {
      return validateAndReturnAPI(this.apiKeysApi);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(CogniteClient.prototype, "login", {
    get: function get() {
      return this.loginApi;
    },
    enumerable: true,
    configurable: true
  });
  return CogniteClient;
}();

function onAuthenticateWithRedirect(login) {
  login.redirect({
    redirectUrl: window.location.href
  });
}

function onAuthenticateWithPopup(login) {
  login.popup({
    redirectUrl: window.location.href
  });
}

function responseTransformer(axiosResponse) {
  var data = axiosResponse.data,
      headers = axiosResponse.headers,
      status = axiosResponse.status;
  return {
    data: data,
    headers: headers,
    status: status
  };
} // Copyright 2019 Cognite AS


exports.loginPopupHandler = loginPopupHandler$$1;
exports.isLoginPopupWindow = isLoginPopupWindow$$1;
exports.CogniteClient = CogniteClient;
exports.POPUP = POPUP;
exports.REDIRECT = REDIRECT;